import React, { Component } from 'react';
import offerIcon from './../../../../assets/img/offer_icon.png';


export default class ProductInfo extends Component {

	render() {
		const { product } = this.props;
		return (
			<div>
				<div className="row">
					<div className="col-xs-4" style={{ textAlign: 'center' }}>
						<img src={product.productInfoResponse.imageUrls[0].thumbnail} style={{ maxWidth: '100%', maxHeight: '100px' }} alt="product" />
					</div>
					<div className="col-xs-8 no-left-padding">
						{
							// <div className="l-imp-txt">{product.productInfoResponse.jpin}</div>
						}
						<div className="v-imp-txt top-ten">{product.productInfoResponse.title}</div>
						<div className="pr-mrp top-ten">MRP {product.mrp}</div>
					</div>
				</div>
				{(product.manufacturerOffer) ?
					<div style={{ padding: '10px 0' }}>
						<img src={offerIcon} alt="offer" /> {product.manufacturerOffer.title}
					</div> : null
				}
				<div style={{ borderBottom: '2px solid #dfdfdf', marginTop: '10px' }}></div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/Inwarding/Components/Commons/ProductInfo.js